export const links = {
  main: '/',
  login: '/login',
};

export default links;
